import React, {Component} from "react";
import {Link} from "react-router-dom";

class footer extends React.Component {
  constructor(props) {
    super(props);
    this.openCookieSettings = this.openCookieSettings.bind(this);
  }
  openCookieSettings(e) {
    e.preventDefault();
    if (window.UC_UI && typeof window.UC_UI.showSecondLayer === "function") {
      window.UC_UI.showSecondLayer();
    } else {
      console.warn("Usercentrics hasn’t loaded yet.");
    }
  }
  render() {
    return (
      <div>
        {/*==================== Footer ====================*/}
        {/* Footer Section Start */}
        <footer className="footer-area pt-100 pb-70">
          <div className="row" style={{margin: "6%"}}>
            <div className="col-lg-3 col-sm-6">
              <div className="footer-widget">
                <div className="footer-logo">
                  <Link to="/">
                    <img
                      src="../../../img2/logo.png"
                      alt="logo"
                      style={{width: "150px", marginTop: "20px"}}
                    />
                  </Link>
                </div>
                <p>
                  Jobs für Krankenpfleger, Altenpfleger, MTRA, OTA, Erzieher,
                  Psychologen...
                </p>
                <div className="footer-social">
                  <a
                    href="https://www.facebook.com/hellosister.de"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="bx bxl-facebook" />
                  </a>
                  <a
                    href="https://www.instagram.com/hellosister_de/"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCbl4pNjmCORo30na8VM364g"
                    target="_blank"
                    rel="noopener noreferrer">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
                <div className="footer-social" style={{marginTop: "10px"}}>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.guelgmbh.hellosister"
                    target="_blank"
                    rel="noopener noreferrer">
                    <img
                      style={{width: "40%"}}
                      src="../../img2/Google_play_logo.png"
                      alt="referal image"
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/app/id1635731952"
                    target="_blank"
                    rel="noopener noreferrer">
                    <img
                      style={{width: "40%"}}
                      src="../../img2/Apple_store_logo.png"
                      alt="referal image"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="footer-widget pl-60">
                <h3>Hello-Sister</h3>
                <ul>
                  <li>
                    <Link to="/UberUns">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Über Uns
                    </Link>
                  </li>
                  {/* <li>
                    <a href="https://unternehmen.hello-sister.de">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Für Unternehmen
                    </a>
                  </li> */}
                  {/* <li>
                                    <Link to="/jobs-suchen">
                                      <i className="bx bx-chevrons-right bx-tada" />
                                      Jobs suchen
                                    </Link>
                                  </li> */}
                  <li>
                    <Link to="/impressum">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Impressum
                    </Link>
                  </li>
                  <li>
                    <Link to="/kontakt">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Kontakt
                    </Link>
                  </li>
                  <li>
                    <Link to="/AGB">
                      <i className="bx bx-chevrons-right bx-tada" />
                      AGB
                    </Link>
                  </li>
                  <li>
                    <Link to="/datenschutz">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Datenschutz
                    </Link>
                  </li>

                  <li>
                    <i
                      className="bx bx-chevrons-right bx-tada"
                      style={{
                        fontSize: "18px",
                        color: "#45adff",
                        marginRight: "7px",
                        marginLeft: "-2px",
                      }}
                    />
                    {/* <button id="ot-sdk-btn" className="ot-sdk-show-settings" style={{
                      background: 'transparent',
                      border: 'none',
                      color: '#d3d3d3',
                      fontSize: '16px',
                      padding: '0',
                      marginLeft: '-4px'

                    }}>Cookie-Richtlinie</button> */}
                    <a href="#!" onClick={this.openCookieSettings}>
                      Cookie-Richtlinie
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="footer-widget pl-60">
                <h3>Bewerber</h3>
                <ul>
                  <li>
                    <Link to="/">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Für Bewerber
                    </Link>
                  </li>
                  {/*             <li>
                    <Link to="/faq">
                      <i className="bx bx-chevrons-right bx-tada" />
                      FAQ
                    </Link>
                  </li>
               <li>
                    <Link to="/register">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Registrieren
                    </Link>
                  </li>
                  <li>
                    <Link to="/faq">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Hilfe-Center
                    </Link>
                  </li> */}
                  {/* <li>

                    <i className="bx bx-chevrons-right bx-tada" />
                    <button id="ot-sdk-btn" className="ot-sdk-show-settings" style={{
                      background: 'transparent',
                      border: 'none',
                      color: '#dededebd',
                      fontSize: '13px',
                      transition: '0.3s',
                      fontWeight: '300'

                    }}>Cookie-Einstellungen</button>

                  </li> */}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="footer-widget footer-info">
                <h3>Unternehmen</h3>
                <ul>
                  <li>
                    <a href="https://unternehmen.hello-sister.de">
                      <i className="bx bx-chevrons-right bx-tada" />
                      Für Unternehmen
                    </a>
                  </li>
                  {/*     <li style={{padding:'0'}}>
                    <a href="https://unternehmen.hello-sister.de/unternehmen_faq/">
                      <i className="bx bx-chevrons-right bx-tada" />
                      FAQ
                    </a>
                  </li>
                   <li>
                    <span>
                      <i className="bx bxs-phone" />
                      Phone:
                    </span>
                    <a href="tel:+4968168635374">
                      +49 (681) 68 63 53 74
                    </a>
                  </li>
                  <li>
                    <span>
                      <i className="bx bxl-whatsapp" />
                      WhatsApp:
                    </span>
                    <a href="https://wa.me/491624970162" target="_blank" rel="noopener noreferrer">
                      +49 (162) 49 70 162
                    </a>
                  </li>
                  <li>
                    <span>
                      <i className="bx bxs-envelope" />
                      Email:
                    </span>
                    <a href="mailto:kunden@guel.gmbh">
                      kunden@guel.gmbh
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
            {/* <div className="col-lg-3 col-sm-6">
              <div className="footer-widget">
                <div className="category-card">
                  <img src="../img2/referal.png" alt="" />

                  <p>Empfiehl einen Freund oder eine Freundin, und erhalte 200 €, wenn sie einen Job finden</p>
                  <div className="home-btn">
                    <Link to="/register" style={{ padding: '10px', backgroundColor: "#45adff", color: 'white' }}>

                      Jetzt Freunde werben

                    </Link>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </footer>
        <div className="copyright-text text-center">
          <p>
            {new Date().getFullYear()} hello-sister.de - Jobs im
            Gesundheitswesen. Alle Rechte vorbehalten.
          </p>
        </div>
        {/* Footer Section End */}
      </div>
    );
  }
}

export default footer;
